/* Carrier (ClickPost) API logs for the shipment, loaded automatically when the details page
   opens. Fetched on its own so a slow or failed log lookup never holds up the rest of the page. */
import React, { useEffect, useState } from 'react'
import { Box, CircularProgress, Link, Typography } from '@mui/material'
import { SectionCard, T } from './detailKit'
import CarrierLogPanels, { fetchCarrierLogs } from '../../Clickpost Logs/CarrierLogPanels'

export default function CarrierLogsSection({ reference }) {
  const [logs, setLogs] = useState([])
  const [status, setStatus] = useState('idle') // idle | loading | done | error

  useEffect(() => {
    if (!reference) return
    // Ignore a response that lands after the user has moved to another shipment.
    let cancelled = false
    setLogs([])
    setStatus('loading')
    fetchCarrierLogs(reference)
      .then((data) => {
        if (cancelled) return
        setLogs(data)
        setStatus('done')
      })
      .catch((err) => {
        if (cancelled) return
        console.error('Carrier logs fetch failed for reference=' + reference, err)
        setStatus('error')
      })
    return () => { cancelled = true }
  }, [reference])

  if (!reference) return null

  const message = (text) => (
    <Typography sx={{ fontFamily: T.FONT, fontSize: 12.5, color: T.SUBTLE }}>{text}</Typography>
  )

  return (
    <SectionCard
      title='Carrier Logs'
      action={
        <Link href={`/tools/carrier-logs?reference=${encodeURIComponent(reference)}`} target='_blank' rel='noopener noreferrer' underline='hover' sx={{ fontSize: 12, color: T.PRIMARY }}>
          Open in new tab
        </Link>
      }
    >
      {status === 'loading' && (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <CircularProgress size={16} />
          {message('Loading carrier logs…')}
        </Box>
      )}
      {status === 'error' && message('Could not load carrier logs. Try "Open in new tab".')}
      {status === 'done' && logs.length === 0 && message('No carrier logs found for this shipment.')}
      {status === 'done' && logs.length > 0 && (
        <Box sx={{ pt: 1 }}>
          <CarrierLogPanels logs={logs} />
        </Box>
      )}
    </SectionCard>
  )
}
